import { useSurfacePreferenceProperty } from "@/components/preferences/usePreferences.tsx";

/** Whether single-key keyboard shortcuts are enabled via user preferences. */
export const useKeyboardShortcutsEnabled = (): boolean => {
  const shortcutsEnabled = useSurfacePreferenceProperty("keyboard", "shortcutsEnabled");
  return shortcutsEnabled === "enabled";
};
